import * as S from './style';

function GillHubItem () {
    return <S.GillHubItem>
        <h2>Gill</h2>
        <p>Sou o porta-voz do Open Farm® e estarei sempre por perto</p>
    </S.GillHubItem>
}

export default GillHubItem